module.exports = __webpack_public_path__ + "media/images/landing_page/2023/tools/vision_ru-b836926d77dd290fcab5e81695733989.webp";